import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonRedraw } from './ObjectiveTypeBaseReasonRedraw.schema';
import { importantOptions } from '../global/ImportantOption.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      type: enumRequired(Joi, importantOptions, labeled(label, 'Redraw'))
    })
    .when(Joi.object({ type: Joi.any().valid(1) }), {
      then: Joi.object({
        reason: objectiveTypeBaseReasonRedraw(
          Joi,
          labeled(label, 'Where having a redraw feature is important, why? - ')
        )
      })
    });

export default {
  schema
};
